import { getCookie } from 'cookies-next';

export default function getTokenFromCookie() {
  const accessToken = getCookie('accessToken') as string;
  const refreshToken = getCookie('refreshToken') as string;

  return {
    accessToken: accessToken ?? null,
    refreshToken: refreshToken ?? null,
  };
}
